import { jsx as _jsx } from "react/jsx-runtime";
export function getBoxes(data) {
    const boxes = [];
    getBoxesSS(data, boxes);
    return boxes;
}
function getBoxesSS(data, boxes) {
    for (let i = 0; i < data.length; i++) {
        const datum = data[i];
        boxes.push(_jsx("g", { transform: 'translate(' + datum.position.x + ' ' + datum.position.y + ')', children: datum.content }));
        if (datum.children) {
            getBoxesSS(datum.children, boxes);
        }
    }
}
//# sourceMappingURL=getBoxes.js.map